// Balloon asset paths — 3D inflatable-style objects generated via Nano Banana.
// Served from /public/balloons.
export const BALLOONS = {
  camera: "/balloons/camera.png",
  teddy: "/balloons/teddy-graduation.png",
  books: "/balloons/books.png",
  sunflower: "/balloons/sunflower.png",
  leaf: "/balloons/leaf.png",
  snowman: "/balloons/snowman.png",
  butterfly: "/balloons/butterfly.png",
  butterflyPink: "/balloons/butterfly-pink.png",
  butterflyBlue: "/balloons/butterfly-blue.png",
  heartBlack: "/balloons/heart-black-new.png",
  heartSilver: "/balloons/heart-silver-new.png",
  heartGold: "/balloons/heart-gold.png",
  loveHeart: "/balloons/love-heart.png",
  goldMedal: "/balloons/gold-medal.png",
};

export const BRAND = {
  logo: "/brand/logo.png",
  heart: "/brand/heart.png",
};

export const CONTACT = {
  brand: "Love Exclusive Photography",
  tagline: "Premium nursery & school photography",
  email: "hello@loveexclusive.co.uk",
  phone: "+44 20 4571 8820",
  location: "London, United Kingdom",
  instagram: "@loveexclusivephotography",
  instagramUrl: "https://instagram.com/loveexclusivephotography",
};

export const MEDIA = BALLOONS;
